@if (object.content.length == 0) {
  <div (click)="selectedProperty.emit(object)">
    {{object.name}}
  </div>
}
@if (object.content.length > 0) {
  <div [menuFor]="sub">
    {{object.name}}
  </div>
  <menu #sub class="no-margin">
    @for (prop of object.content; track prop) {
      <div menu-item>
        <property-node [object]="prop" (selectedProperty)="selectedProperty.emit($event)"></property-node>
      </div>
    }
  </menu>
}
